/**
 * Service Nation sites `/edge-auth` accepts as a `destinationUrl` (SN-1167), mirroring
 * `destination_url_domains` in Service Nation's `config/edge.php`:
 * - ASP: members.servicenation.com, servicenation.dev, <name>.servicenation.dev
 * - Laravel: app.servicenation.com, app.servicenation.dev, <name>.app.servicenation.dev
 * Edge itself also runs on *.servicenation.com (e.g. everpro.servicenation.com), so those hosts
 * must not match.
 */
const SERVICE_NATION_HOST =
  /^(members\.servicenation\.com|app\.servicenation\.com|([a-z0-9-]+\.)?(app\.)?servicenation\.dev)$/i;

// Paths `/edge-auth` rejects (`destination_url_blocked_paths`): its own login entry points
const BLOCKED_PATH = /^\/(edge-auth|edge-forward|new-login\.asp)(\/|$)/i;

/**
 * Returns the link as a full URL when it points at a Service Nation page `/edge-auth`
 * can sign the member into, or null for any other link.
 */
export const getServiceNationDestinationUrl = (href: string): string | null => {
  let url: URL;
  try {
    url = new URL(href, window.location.href);
  } catch {
    return null;
  }

  if (url.protocol !== 'https:' || url.port || url.username || url.password) return null;
  if (url.origin === window.location.origin || !SERVICE_NATION_HOST.test(url.hostname)) return null;
  if (BLOCKED_PATH.test(url.pathname)) return null;

  return url.toString();
};
